export default [
  {
    id: 1,
    score: 650000,
    wallet: 65000,
    created_at: "۲۰:۳۵:۰۰ ۱۴۰۱/۰۷/۱۵",
  },
  {
    id: 2,
    score: 800000,
    wallet: 80000,
    created_at: "۰۸:۳۰:۰۰ ۱۴۰۱/۰۷/۲۰",
  },
  {
    id: 3,
    score: 100000,
    wallet: 10000,
    created_at: "۱۵:۰۹:۰۰ ۱۴۰۱/۰۷/۲۵",
  },
];
